import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import BordereauxRejetCollectivite from '../../../interfaces/pieces/bordereaux/BordereauxRejetCollectivite';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

class BordereauRejeterCollectiviteAction extends BaseLiquidationAction<
BordereauxRejetCollectivite | BordereauWithState
, BordereauActionType> {
  constructor(options: BaseLiquidationOptions = null) {
    super(options);
    this.label = 'Rejeter le bordereau à l’initiative de la collectivité';
    this.type = BordereauActionType.REJETER_COLLECTIVITE;
  }

  execute = (_bordereau: BordereauWithState): TreeviewActionResult<BordereauWithState> => ({
    type: ActionResultType.MODAL,
    extraProps: {
      isSuperUser: this.isSuperUser,
      bordereauRejeterCollectiviteModal: {
        visible: true,
      },
    },
  });

  executeAction = (
    data: BordereauxRejetCollectivite,
  ): TreeviewActionResult<BordereauWithState>[] => {
    const { nouveauBordereau, ancienBordereau } = data;
    return (
      [
        {
          type: ActionResultType.UPDATE,
          result: Promise.resolve(ancienBordereau),
          shouldRefreshChildren: true,
        },
        {
          type: ActionResultType.ADD,
          result: Promise.resolve(nouveauBordereau),
          shouldRefreshChildren: true,
        },
      ]
    );
  };
}

export default BordereauRejeterCollectiviteAction;
